// Customizer const
export const TOGGLE_COLLAPSED_NAV = "toggle_collapse_menu";
export const DRAWER_TYPE = "drawer_type";
export const FIXED_DRAWER = "fixed_drawer";
export const COLLAPSED_DRAWER = "collapsible";
export const MINI_DRAWER = "mini_drawer";
export const THEME_COLOR = "theme_color";
export const DARK_THEME = "dark_theme";
export const WINDOW_WIDTH = "window-width";
export const SWITCH_LANGUAGE = "switch-language";
export const CHANGE_DIRECTION = "change-direction";

export const MUDAR = "mudar";

export const MOSTRAR_MENSAGEM = "mostrar_mensagem";
export const ESCONDER_MENSAGEM = "esconder_mensagem";
// Motoristas
export const BUSCAR_TODOS_MOTORISTAS = "buscar_todos_motoristas";
export const BUSCAR_TODOS_MOTORISTAS_SUCESSO =
    "buscar_todos_motoristas_sucesso";
export const MENSAGEM_MOTORISTAS = "mensagem_motoristas";
export const SET_MOTORISTA_EDICAO = "set_motorista_edicao";
export const CADASTRAR_MOTORISTA = "cadastrar_motorista";
export const CADASTRAR_MOTORISTA_SUCESSO = "cadastrar_motorista_sucesso";

// Remetentes
export const BUSCAR_TODOS_REMETENTES = "buscar_todos_remetentes";
export const BUSCAR_TODOS_REMETENTES_SUCESSO =
    "buscar_todos_remetentes_sucesso";
export const SET_REMETENTE_SELECIONADO = "set_remetente_selecionado";
export const MOSTRAR_LOADING_REMETENTES = "mostrar_loading_remetentes";
export const ESCONDER_LOADING_REMETENTES = "esconder_loading_remetentes";

//Devolucao
export const EDITAR_DEVOLUCAO = "editar_devolucao";
export const SET_REQUEST = "set_request";

//Cte
export const CLICK_UPDATE_VALUE = "click_update_value";
export const BUSCAR_NOTAS_CTE = "buscar_notas_cte";
export const BUSCAR_NOTAS_CTE_SUCESSO = "buscar_notas_cte_sucesso";
export const BUSCAR_CIDADE_CTE = "buscar_cidade_cte";
export const BUSCAR_CIDADE_CTE_SUCESSO = "buscar_cidade_cte_sucesso";

//Romaneios
export const GERAR_ROMANEIOS = "gerar_romaneios";
export const GERAR_ROMANEIOS_SUCESSO = "gerar_romaneios_sucesso";
export const MOSTRAR_MENSAGEM_ROMANEIOS = "mostrar_mensagem_romaneios";
export const SET_DATA_INICIO_ROMANEIO = "set_data_inicio_romaneio";
export const SET_DATA_FIM_ROMANEIO = "set_data_fim_romaneio";
export const SET_LOAD_GERAR_ROMANEIOS = "set_load_gerar_romaneios";
export const ESCONDER_MENSAGEM_ROMANEIOS = "esconder_mensagem_romaneios";
export const ORDER_BY_ROMANEIOS = "order_by_romaneios";
export const SET_LINHAS_POR_PAGINA_ROMANEIOS =
    "set_linhas_por_pagina_romaneios";
export const MUDAR_PAGINA_ROMANEIOS = "mudar_pagina_romaneios";
export const ROMANEIOS_ORDENAR = "romaneios_ordenar";
export const MARCAR_ROMANEIOS = "marcar_romaneios";
export const MARCAR_TODOS_ROMANEIOS = "marcar_todos_romaneios";
export const DESMARCAR_TODOS_ROMANEIOS = "desmarcar_todos_romaneios";
export const GERAR_ROMANEIOS_LIBERADO = "gerar_romaneios_liberado";
export const GERAR_ROMANEIOS_AUTOMATICO = "gerar_romaneios_automatico";
export const GERAR_ROMANEIOS_AUTOMATICO_SUCESSO =
    "gerar_romaneios_automatico_sucesso";
export const SET_LOAD_GERAR_ROMANEIOS_AUTOMATICO =
    "set_load_gerar_romaneios_automatico";
export const CRIAR_ROMANEIO_SEM_VERIFICAR = "criar_romaneio_sem_verificar";
export const LOAD_ROMANEIOS = "load_romaneios";

// Destinatarios
export const BUSCAR_TODOS_DESTINATARIOS = "buscar_todos_destinatarios";
export const BUSCAR_TODOS_DESTINATARIOS_SUCESSO =
    "buscar_todos_destinatarios_sucesso";
export const DESTINATARIOS_MENSAGEM = "destinatarios_mensagem";
export const SET_ESTADO_SELECIONADO = "set_estado_selecionado";
export const SET_CIDADE_SELECIONADA = "set_cidade_selecionada";
export const HABILITAR_ESTADO = "habilitar_estado";
export const DESATIVAR_DEST_SEM_ROTA = "desativar_dest_sem_rota";
export const SET_DEST_TABELA = "set_dest_tabela";
export const BUSCAR_DESTINATARIOS_CIDADE = "buscar_destinatarios_cidade";
export const BUSCAR_DESTINATARIOS_CIDADE_SUCESSO =
    "buscar_destinatarios_cidade_sucesso";
export const MOSTRAR_LOAD_LISTA_DESTINATARIOS =
    "mostrar_load_lista_destinatarios";
export const MARCAR_DESTINATARIO_SELECIONADO =
    "marcar_destinatario_selecionado";
export const MARCAR_SELECIONADO_TODOS_DESTINATARIOS =
    "marcar_selecionado_todos_destinatarios";
export const DESMARCAR_SELECIONADO_TODOS_DESTINATARIOS =
    "desmarcar_selecionado_todos_destinatarios";
export const ENVIAR_DESTINATARIOS_SELECIONADOS =
    "enviar_destinatarios_selecionados";
export const CHANGE_NAVIGATION_STYLE = "change-navigation-style";
export const HORIZONTAL_NAVIGATION = "horizontal_navigation";
export const VERTICAL_NAVIGATION = "vertical_navigation";
export const ORDER_BY_DEST = "order_by_dest";
export const LINHAS_POR_PAGINA_DEST = "linhas_por_pagina_dest";
export const MUDAR_PAGINA_DEST = "mudar_pagina_dest";
export const SET_DEST_INDEX_SELECIONADOS = "set_dest_index_selecionados";
export const ROTAS_ORDENAR_DEST_SELECIONADOS =
    "rotas_ordenar_dest_selecionados";
export const HORIZONTAL_MENU_POSITION = "horizontal_menu_position";
export const ABOVE_THE_HEADER = "above_the_header";
export const INSIDE_THE_HEADER = "inside_the_header";
export const BELOW_THE_HEADER = "below_the_header";
export const VERIFICAR_DESTINATARIOS_ASSOCIADOS =
    "verificar_destinatarios_associados";
export const VERIFICAR_DESTINATARIOS_ASSOCIADOS_SUCESSO =
    "verificar_destinatarios_associados_sucesso";
export const VERIFICAR_DESTINATARIOS_ASSOCIADOS_DADOS =
    "verificar_destinatarios_associados_dados";
export const SET_DEST_STATUS = "set_dest_status";
export const SET_DEST_STATUS_SUCESSO = "set_dest_status_sucesso";
export const SELECIONAR_DEST_DIST_ROTA = "selecionar_dest_dist_rota";
export const COLUNAS_TABELA_DEST = "colunas_tabela_dest";
export const MUDAR_TIPO_DEST_TABELA = "mudar_tipo_dest_tabela";
export const ABRIR_DEST_SELECIONADO = "abrir_dest_selecionado";
export const BUSCAR_DEST_POR_ESTADO = "buscar_dest_por_estado";
export const BUSCAR_DEST_POR_ESTADO_SUCESSO = "buscar_dest_por_estado_sucesso";
export const MUDAR_NIVEL_TABELA_DEST = "mudar_nivel_tabela_dest";
export const SET_LOADER_LISTA_DESTINATARIOS = "set_loader_lista_destinatarios";
export const LIMPAR_TABELA_DEST = "limpar_tabela_dest";
export const SET_TIPO_TABELA_DEST = "set_tipo_tabela_dest";
//Rota Module const
export const BUSCAR_TODAS_ROTAS = "buscar_todas_rotas";
export const GET_TODAS_ROTAS = "get_todas_rotas";
export const ADICIONAR_NOVA_ROTA = "adicionar_nova_rota";
export const ATUALIZAR_ROTA = "atualizar_rota";
export const ATUALIZAR_ROTA_SUCESSO = "atualizar_rota_sucesso";
export const ADICIONAR_NOVA_ROTA_SUCESSO = "adicionar_nova_rota_sucesso";
export const BUSCAR_TODAS_ROTAS_SUCESSO = "buscar_todas_rotas_sucesso";
export const NOVA_ROTA_TELA = "nova_rota_tela";
export const MARCAR_DESTINATARIO_SELECIONADO_ROTA =
    "marcar_destinatario_selecionado_rota";
export const MARCAR_TODOS_DEST_SELECIONADO_ROTA =
    "marcar_todos_dest_selecionado_rota";
export const DESMARCAR_TODOS_DEST_SELECIONADO_ROTA =
    "desmarcar_todos_dest_selecionado_rota";
export const SET_DADOS_ROTA_EDICAO = "set_dados_rota_edicao";
export const DELETAR_ROTA = "deletar_rota";
export const DELETAR_ROTA_SUCESSO = "deletar_rota_sucesso";
export const DELETAR_ROTAS_SELECIONADAS = "deletar_rotas_selecionadas";
export const DELETAR_ROTAS_SELECIONADAS_SUCESSO =
    "deletar_rotas_selecionadas_sucesso";
export const SET_TELA_ROTA = "set_rota_tela";
export const BUSCAR_DADOS_ROTA_EDICAO = "buscar_dados_rota_edicao";
export const BUSCAR_DADOS_ROTA_EDICAO_SUCESSO =
    "buscar_dados_rota_edicao_sucesso";
export const ESCONDER_LOAD_ROTAS = "esconder_load_rotas";
export const DELETAR_DEST_ROTA = "deletar_dest_rota";
export const SHOW_MESSAGE = "show_message";
export const HIDE_MESSAGE = "hide_message";
export const ATIVAR_EDITAR_ROTA = "ativar_editar_rota";
export const EDITAR_ROTA = "editar_rota";
export const EDITAR_ROTA_SELECIONADA_SUCESSO =
    "editar_rotas_selecionadas_sucesso";
export const ADICIONAR_DESTINATARIOS_SELECIONADOS_ROTAS =
    "adicionar_destinatarios_selecionados_rotas";
export const FETCH_ALL_ROTA = "fetch_all_rota";
export const FETCH_ALL_ROTA_SUCCESS = "fetch_all_rota_success";
export const ADD_FAVOURITE = "add_favourite";
export const ON_ROTA_SELECT = "on_rota_select";
export const ON_ADD_ROTA = "on_add_rota";
export const ON_ROTA_CLOSE = "on_rota_close";
export const ON_FILTER_OPTION_SELECT = "on_filter_option_select";
export const ON_SAVE_ROTA = "on_save_rota";
export const MOSTRAR_LOAD_ROTA = "mostrar_load_rota";
export const FILTER_ROTA = "filter_rota";
export const GET_ALL_ROTA = "get_all_rota";
export const GET_UNSELECTED_ALL_ROTA = "get_unselected_all_rota";
export const ON_ALL_ROTA_SELECT = "on_all_rota_select";
export const UPDATE_SEARCH_USER = "update_search_user";
export const ON_TOGGLE_DRAWER = "on_toggle_drawer";
export const HANDLE_REQUEST_CLOSE = "handle_request_close";
export const HIDE_ROTA_LOADER = "hide_rota_loader";
export const SET_INDEX_ROTAS_SELECIONADAS = "set_index_rotas_selecionadas";
export const SET_CNPJ_EMPRESA = "set_cnpj_empresa";
export const SET_ROTAS_SELECIONADAS = "set_rotas_selecionadas";
export const RESET_DELETAR_DEST_ROTA = "reset_deletar_dest_rota";
export const ORDEM_FIM = "ordem_fim";
//Auth const
export const SIGNUP_USER = "signup_user";
export const SIGNUP_USER_SUCCESS = "signup_user_success";
export const SIGNIN_USER = "signin_user";
export const SIGNIN_USER_SUCCESS = "signin_user_success";
export const SIGNOUT_USER = "signout_user";
export const SIGNOUT_USER_SUCCESS = "signout_user_success";
export const INIT_URL = "init_url";
export const ON_SHOW_LOADER = "on_show_loader";
